import NextImage from 'next/image';
// import { appsignal, errorTypes, tags } from '@/crash_reporter';

export function Image(props) {
  return <NextImage {...props} onError={handleError} />;
}

function handleError(event) {
  // const { src, alt } = event.target;
  // const span = appsignal.createSpan();
  // span
  //   .setError(new Error(errorTypes.image))
  //   .setTags(tags)
  //   .setParams({ src, alt });
  // appsignal.send(span);
}
